<template>
  <Modal id="CompanyDetail" width="60%" :visible="visible" @cancel="visible = !visible" @ok="visible = !visible" :title="$t('authority.name.detailTitle')" :zIndex="9999999900">
    <Descriptions >
        <DescriptionsItem :label="$t('authority.field.id_aut')">{{data.idAut}}</DescriptionsItem>
        <DescriptionsItem :label="$t('authority.field.a_id_aut')">{{data.aIdAut}}</DescriptionsItem>
        <DescriptionsItem :label="$t('authority.field.name')">{{data.name}}</DescriptionsItem>
        <DescriptionsItem :label="$t('authority.field.resource_name')">{{data.resourceName}}</DescriptionsItem>
        <DescriptionsItem :label="$t('authority.field.type')">{{data.type}}</DescriptionsItem>
  </Descriptions>
  </Modal>
</template>

<script>
import { Modal, Descriptions,DescriptionsItem } from "ant-design-vue";
import { LoadingOutlined, PlusOutlined } from "@ant-design/icons-vue";

export default {
  name: "AuthorityDetail",
  components: {
    Modal,
    LoadingOutlined,
    PlusOutlined,
    Descriptions,
    DescriptionsItem,
  },
  data() {
    return {
      data: {
      },
      visible: false,
    };
  },
  computed: {
  },
  methods: {
    async detailShow(obj) {
      this.data = JSON.parse(JSON.stringify(obj));
      this.visible = true;
    },
  },
}
</script>

<style lang="less">
</style>